import { useMemo, useState } from "react";
import { LatLngLiteral } from "leaflet";

interface UseGeofenceMapContainerProps {
	areaSelectorVisible?: boolean;
	selectedGeofence: LatLngLiteral[];
	clearGeofence: () => void;
	handleEnableAreaSelector?: (value: boolean) => void;
	errors: { geofence?: string;[key: string]: any };
	touched: { geofence?: boolean;[key: string]: any };
	onBackToTypeSelection?: () => void;
}

export const useGeofenceMapContainer = ({
	areaSelectorVisible,
	selectedGeofence,
	clearGeofence,
	handleEnableAreaSelector,
	errors,
	touched,
	onBackToTypeSelection,
}: UseGeofenceMapContainerProps) => {
	const [isDropZoneVisible, setIsDropZoneVisible] = useState(false);

	const showBackButton = useMemo(
		() => areaSelectorVisible || isDropZoneVisible || selectedGeofence?.length > 0 || Boolean(onBackToTypeSelection),
		[areaSelectorVisible, isDropZoneVisible, selectedGeofence?.length, onBackToTypeSelection]
	);

	const handleBack = () => {
		if (onBackToTypeSelection) {
			setIsDropZoneVisible(false);
			handleEnableAreaSelector?.(false);
			onBackToTypeSelection();
			return;
		}

		if (areaSelectorVisible || isDropZoneVisible || selectedGeofence?.length > 0) {
			clearGeofence();
			setIsDropZoneVisible(false);
			handleEnableAreaSelector?.(false);
		}
	};

	const hasGeofenceError = useMemo(
		() => Boolean(errors.geofence && touched.geofence),
		[errors.geofence, touched.geofence]
	);

	return {
		isDropZoneVisible,
		setIsDropZoneVisible,
		showBackButton,
		handleBack,
		hasGeofenceError,
	};
};